import { auth } from './firebase';

const API_URL = import.meta.env.VITE_API_URL;

interface RequestOptions extends RequestInit {
  requireAuth?: boolean;
}

export async function apiRequest(
  endpoint: string,
  options: RequestOptions = {}
): Promise<Response> {
  const { requireAuth = true, ...fetchOptions } = options;
  
  // Get Firebase ID token if authentication is required
  let headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  
  // Merge additional headers if provided
  if (fetchOptions.headers) {
    const additionalHeaders = fetchOptions.headers as Record<string, string>;
    headers = { ...headers, ...additionalHeaders };
  }
  
  if (requireAuth) {
    const token = await auth.getIdToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }
  
  return fetch(`${API_URL}${endpoint}`, {
    ...fetchOptions,
    headers,
  });
}

export async function apiGet(endpoint: string, requireAuth = true) {
  return apiRequest(endpoint, { method: 'GET', requireAuth });
}

export async function apiPost(
  endpoint: string,
  data: any,
  requireAuth = true,
  additionalOptions?: Partial<RequestInit>
): Promise<Response> {
  return apiRequest(endpoint, {
    method: 'POST',
    body: JSON.stringify(data),
    requireAuth,
    ...additionalOptions,
  });
}

export async function apiPut(endpoint: string, data: any, requireAuth = true) {
  return apiRequest(endpoint, {
    method: 'PUT',
    body: JSON.stringify(data),
    requireAuth,
  });
}

export async function apiDelete(endpoint: string, requireAuth = true) {
  return apiRequest(endpoint, { method: 'DELETE', requireAuth });
}